import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertTriangle } from 'lucide-react';
import { campaignsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import moment from 'moment';
import React from 'react';
import CampaignTabHeader from '../campaign-tab-header';
import CampaignSummaryAudienceDialog from './campaign-summary-audience-dialog';
import CampaignSummaryMessageTemplateDialog from './campaign-summary-message-template-dialog';
import CampaignSummaryTimingDialog from './campaign-summary-timing-dialog';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';
import ReviewAskCard from '@common/components/nudge-banner/review-ask-card';


type Props = {
  campaignId?: string;
}


const BulkDBFinish = React.forwardRef<HTMLDivElement, Props>(({ campaignId }: Props, ref) => {
  const { t } = useTranslation(namespace);
  let campaign
  const _campaign = useAppSelector((state) => campaignsSelectOneObjectByQuery(state.DBCampaignReducer, { _id: campaignId }))
  const newCampaign = useAppSelector((state) => state.CampaignReducer.newCampaign)

  if (campaignId) campaign = _campaign
  else campaign = newCampaign

  return (
    <div 
      ref={ref}
      className={cn(
        "flex flex-col items-center",
        "w-full max-w-[750px] mx-auto",
        "px-6 pb-12"
      )}
    >
      {!campaignId && (!campaign?.schedule?.isNow && moment.utc(campaign?.schedule?.dueDate).isBefore(moment.utc().subtract(1, "minute"))) && (
        <Alert className={cn(
          "mb-4 w-full",
          "border-amber-400 dark:border-amber-500",
          "bg-amber-50 dark:bg-amber-950/40",
          "shadow-sm"
        )}>
          <AlertTriangle className="h-4 w-4 text-amber-600 dark:text-amber-400" />
          <AlertTitle className={cn(
            "text-sm font-semibold ml-2",
            "text-amber-900 dark:text-amber-100"
          )}>
            {t('campaign.warning')}
          </AlertTitle>
          <AlertDescription className={cn(
            "mt-0.5 text-xs",
            "text-amber-800 dark:text-amber-200"
          )}>
            <div>{t('campaign.scheduledTimePassed')}</div>
          </AlertDescription>
        </Alert>
      )}
      {!campaignId && (
        <CampaignTabHeader 
          htmlTitle={t('campaign.readyForLaunch')}
          htmlSubTitle={t('campaign.doubleCheckMessage')}
        />
      )}

      {campaignId && <ReviewAskCard campaignId={campaignId} hasError={campaign?.campaignStatus === 'aborted'} />}

      <div className="space-y-6 w-full">
        <CampaignSummaryAudienceDialog campaignId={campaignId} />
        <CampaignSummaryMessageTemplateDialog campaignId={campaignId} />
        <CampaignSummaryTimingDialog campaignId={campaignId} />
      </div>
    </div>
  )
})

export default BulkDBFinish